//
// Visual.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./PositionedModel";
import "../../visualElements/VisualElement";

var Visual = createModule("BIRD::Visual", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::PositionedModel"], EventDispatcher, [
    ,
    {
        visualElement: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default Visual;
